export const queryKeys = {
    PAYMENT_CUSTOM_TYPE: 'PAYMENT_CUSTOM_TYPE',
};
